/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { Component, OnInit } from '@angular/core';
import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'wwg-extrafields',
  templateUrl: './extrafields.component.html',
  styleUrls: ['./extrafields.component.scss']
})
export class ExtrafieldsComponent implements OnInit {

  private maxFields = 30;
  public extraFieldsArray: Array<object> = [];

  constructor(
    private notificationService: NotificationService
  ) { }

  ngOnInit() { }

  public addField() {
    if (this.extraFieldsArray.length < this.maxFields) {
      this.extraFieldsArray.push({ name: '', value: '' });
    } else {
      this.notificationService.open('Max 30 fields allowed.');
    }
  }

  private removeField(index) {
    this.extraFieldsArray.splice(index, 1);
  }

  private getFields() {
    return this.extraFieldsArray;
  }

  private displayFields(fields: Array<object>) {
    if (Array.isArray(fields)) {
      this.extraFieldsArray = fields;
    }
  }
}
